import {Component, OnDestroy, OnInit} from '@angular/core';
import {GameLevelService} from '../../../services/games/game-level/game-level.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PageService} from '../../../services/page/page.service';
import {MetaService} from '../../../services/meta/meta.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {LangTgtService} from '../../../services/lang-tgt/lang-tgt.service';
import {UserService} from '../../../services/user/user.service';
import {AccessService} from '../../../services/access/access.service';
import {MinorRestrictionComponent} from '../../../components/minor-restriction/minor-restriction.component';
import {PremiumModalComponent} from '../../../components/premium-modal/premium-modal.component';
import {CommonModule} from "@angular/common";
import {SpinnerComponent} from "../../../components/spinner/spinner.component";
import {GameImagePipe} from "../../../pipes/game-image.pipe";

@Component({
  selector: 'app-games-theme-levels',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    RouterLink,
    TranslateModule,
    GameImagePipe
  ],
  templateUrl: './games-theme-levels.component.html',
  styleUrls: ['./games-theme-levels.component.scss']
})
export class GamesThemeLevelsComponent implements OnInit, OnDestroy {

  loading = true;
  idTheme: string;
  age: any;
  data: any;
  isPremium = false;
  themePremiumLocked = false;

  constructor(
    private route: ActivatedRoute,
    private modal: NgbModal,
    private router: Router,
    private gameLevelSrv: GameLevelService,
    public langSrcSrv: LangSrcService,
    public langTgtSrv: LangTgtService,
    private accessSrv: AccessService,
    private pageSrv: PageService,
    private metaSrv: MetaService,
    private translate: TranslateService,
    private userSrv: UserService
  ) { }

  async ngOnInit() {
    this.age = await this.userSrv.age();
    this.translate.get(`Chargement...`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
    this.idTheme = this.route.snapshot.params.idTheme;
    this.isPremium = await this.accessSrv.isPremium(this.langTgtSrv.current.code);
    this.themePremiumLocked = this.accessSrv.isThemePremiumLocked(this.langTgtSrv.current, this.isPremium);

    if (this.themePremiumLocked) {
      this.modal.open(PremiumModalComponent, { centered: true });
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'learning', 'dashboard']);
      return;
    }

    await this.initialize();
  }

  async ngOnDestroy() {
    this.pageSrv.displayPurpleMain = false;
  }

  async initialize() {
    this.data = await this.gameLevelSrv.findAllByTheme(this.idTheme);
    if (this.data.theme.minorRestriction && this.age.age <= 18) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'themes']);
    }
    if (!this.data) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'themes']);
      return;
    }
    this.metaSrv.setMetas({title: this.data.theme.translation});
    this.pageSrv.displayPurpleMain = true;
    this.loading = false;
  }

  trackById(index: number, item: any) { return item.id; }

  async navigateToLevel(level: any) {
    if (level.minorRestriction && this.age.age <= 18) {
      const modal = this.modal.open(MinorRestrictionComponent, {
        windowClass: 'modal-white'
      });
      modal.componentInstance.name = level.name;
      return;
    }
    if (this.themePremiumLocked) {
      this.modal.open(PremiumModalComponent, { centered: true });
      return;
    }
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'themes', this.data.theme.uniqid, level.uniqid]);
  }
}
